(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rv-review-snippets-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rv-review-snippets-layout')) {
    customElements.define('rv-review-snippets-layout', class extends HTMLElement {
      connectedCallback() {
        this.product = this.closest('.product');
        if (!this.product) return;
        this.desktop = window.matchMedia('(min-width: 1000px)');
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.product.querySelector('.product-gallery'));
        this.resizeObserver.observe(this.product.querySelector('.product-info'));
        this.desktop.addEventListener('change', this.schedule);
        window.addEventListener('resize', this.schedule);
        this.discoveryObserver = new MutationObserver(this.schedule);
        this.discoveryObserver.observe(this.product, { childList: true, subtree: true });
        this.schedule();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.discoveryObserver?.disconnect();
        this.desktop?.removeEventListener('change', this.schedule);
        window.removeEventListener('resize', this.schedule);
      }

      update() {
        if (!this.isConnected) return;
        if (!this.block) {
          const widget = this.product.querySelector('.jdgm-review-snippet-widget-v2');
          this.block = widget?.closest('.product-info__block-item');
          if (!this.block) return;
          this.origin = document.createComment('');
          this.block.before(this.origin);
          this.discoveryObserver.disconnect();
          this.resizeObserver.observe(this.block);
        }

        if (!this.desktop.matches) {
          if (this.block.parentElement === this && this.origin.isConnected) {
            this.origin.after(this.block);
          }
          this.removeAttribute('data-active');
          this.style.removeProperty('--rv-snippet-gap');
          return;
        }

        const target = this.product.querySelector(this.dataset.alignment === 'gift' ? '.rvm-gift' : '.buy-buttons');
        const gallery = this.product.querySelector('.product-gallery');
        if (!target || !gallery) return;
        if (this.block.parentElement !== this) this.append(this.block);
        this.setAttribute('data-active', '');
        const gap = Math.max(24, target.getBoundingClientRect().top - gallery.getBoundingClientRect().bottom);
        const value = `${Math.round(gap * 100) / 100}px`;
        if (this.style.getPropertyValue('--rv-snippet-gap') !== value) {
          this.style.setProperty('--rv-snippet-gap', value);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
